import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

axios.defaults.withCredentials = true;

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const API_ORIGIN = new URL(process.env.REACT_APP_BACKEND_URL).origin;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = signed in
  const canAuth = window.location.origin === API_ORIGIN;

  useEffect(() => {
    if (!canAuth) {
      setUser(false);
      return;
    }
    axios
      .get(`${API}/auth/me`)
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, [canAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setUser(data);
    return data;
  };

  const register = async (email, password, name) => {
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, canAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
